'use strict';

var StrategyReadonlyClosureActionsController = function StrategyReadonlyClosureActionsController($scope) {
  $scope.filterOutEmptyActions = function (element) {
    return !element.isEmpty();
  };
};
StrategyReadonlyClosureActionsController.$inject = ['$scope'];
module.exports = StrategyReadonlyClosureActionsController;